
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaiairportcab() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Airport Cab',
        heading: 'Meghana Cab : Pune to Mumbai Airport Cab',
        headingDescription: 'Meghana Cab offers Pune to Mumbai Airport Cab services, ensuring timely and hassle-free airport transfers to Chhatrapati Shivaji Maharaj International Airport. Whether you are catching an early morning flight or arriving late at night, our punctual drivers and comfortable cabs make your long-distance airport journey smooth and reliable. Enjoy flexible scheduling, fixed transparent fares, and 24/7 customer support. Book your Pune to Mumbai Airport Cab with Meghana Cab and experience stress-free airport travel with comfort and peace of mind.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "An iconic monument overlooking the Arabian Sea, the Gateway of India was built in 1924 to commemorate the visit of King George V. It is one of Mumbai’s most photographed landmarks and serves as the starting point for ferry rides to Elephanta Caves and Alibaug."
  },
  {
    "title": "Marine Drive",
    "description": "Also known as the Queen’s Necklace, this 3.6 km boulevard stretches along the Arabian Sea. It is popular for evening walks, sunset views, and the glittering skyline. The curved road lined with palm trees offers one of the best urban sea views in India."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site, this historic railway station combines Victorian Gothic architecture with Indian influences. It is both a major transport hub and an architectural marvel with detailed carvings, stained glass, and a bustling atmosphere."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, a short ferry ride from Mumbai, these ancient rock-cut caves date back to the 5th–8th centuries. The caves feature sculptures and carvings dedicated to Lord Shiva, including the famous three-headed Maheshmurti."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant street market known for its eclectic shops, street food, art galleries, and colonial architecture. It's a great place for souvenir shopping and is surrounded by landmark cafes like Leopold and Café Mondegar."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of Mumbai’s most revered temples, dedicated to Lord Ganesha. Devotees from across the country visit for blessings, especially on Tuesdays. The temple's architecture, gold-plated dome, and peaceful ambiance make it spiritually significant."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built on an islet off the coast, this Indo-Islamic shrine houses the tomb of Sufi saint Pir Haji Ali Shah Bukhari. It is accessible via a narrow causeway during low tide and offers a unique blend of spirituality and sea views."
  },
  {
    "title": "Chor Bazaar",
    "description": "One of the oldest flea markets in India, Chor Bazaar is famous for antiques, vintage goods, Bollywood posters, and secondhand treasures. It offers a fascinating look into Mumbai’s historic trade culture."
  },
  {
    "title": "Juhu Beach",
    "description": "A popular beach in the suburbs of Mumbai, known for its street food stalls, leisure crowd, and celebrity sightings. Visitors enjoy pav bhaji, ice gola, and walks along the shoreline, especially during the evenings."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Located in Borivali, this massive national park offers a green escape with hiking trails, lion and tiger safaris, and the historic Kanheri Buddhist caves carved into basalt rock. It’s a blend of nature, history, and recreation."
  }
],

"services": [
    {
        "name": "Pune to Mumbai Airport Taxi Booking",
        "description": "Book reliable and comfortable taxi services from Pune to Mumbai Airport with Meghana Cab. Whether you’re heading to the international or domestic terminals, enjoy timely pickups and smooth rides for a stress-free airport transfer."
    },
    {
        "name": "One Way Airport Cab Pune to Mumbai",
        "description": "Opt for our convenient one-way airport taxi service from Pune to Mumbai. Perfect for travelers who need quick and direct transfers to catch their flights without any delays or hassles."
    },
    {
        "name": "Cab for Mumbai International Airport from Pune",
        "description": "Travel in comfort to Mumbai International Airport with Meghana Cab’s dedicated airport taxi services. Our professional drivers ensure punctual and safe trips, making your airport journey hassle-free."
    },
    {
        "name": "Affordable Pune to Mumbai Airport Taxi",
        "description": "Get budget-friendly taxi options for Pune to Mumbai Airport transfers without compromising on comfort or service quality. Meghana Cab offers transparent pricing and excellent value for money."
    },
    {
        "name": "Pune to Mumbai Domestic Airport Drop",
        "description": "Need a reliable taxi to Mumbai Domestic Airport from Pune? Meghana Cab provides prompt and safe cab services ensuring you reach the domestic terminal well ahead of your flight."
    },
    {
        "name": "AC Cab Hire Pune to Mumbai Airport",
        "description": "Travel in air-conditioned comfort with our AC taxi services from Pune to Mumbai Airport. Stay cool and relaxed even during long journeys, with well-maintained vehicles and professional chauffeurs."
    },
    {
        "name": "Sedan/SUV Pune to Mumbai Airport Ride",
        "description": "Choose from a range of sedans and SUVs for your Pune to Mumbai Airport transfer based on your group size and luggage requirements. Meghana Cab ensures spacious and comfortable rides."
    },
    {
        "name": "24/7 Pune to Mumbai Airport Cab",
        "description": "Our airport taxi service operates 24/7, so you can book a cab anytime from Pune to Mumbai Airport. Whether it’s an early morning flight or a late-night arrival, we’re ready to serve."
    },
    {
        "name": "Express Cab Pune to Airport",
        "description": "In a hurry? Our express taxi service from Pune to Mumbai Airport ensures quick pickups and fast travel, helping you reach the airport on time every time."
    },
    {
        "name": "Pune to Airport Chauffeur Cab",
        "description": "Enjoy professional chauffeur-driven cab services from Pune to Mumbai Airport. Our experienced drivers provide courteous service and ensure a safe and comfortable journey."
    },
    {
        "name": "Outstation Cab Pune to Mumbai Airport",
        "description": "For travelers coming from outstation, Meghana Cab offers specialized cab services from Pune to Mumbai Airport, including long-distance travel with full amenities and comfort."
    },
    {
        "name": "On-Time Cab Pune to Mumbai Airport",
        "description": "Punctuality is our priority. Meghana Cab guarantees on-time pickups and airport drop-offs from Pune to Mumbai, so you never miss your flight."
    },
    {
        "name": "Airport Transfer Cab Pune to Mumbai",
        "description": "Book seamless airport transfer cabs from Pune to Mumbai with Meghana Cab. Our services cover all airport-related travel needs, including luggage assistance and flight monitoring."
    },
    {
        "name": "Prepaid Taxi Pune to Mumbai Airport",
        "description": "Avoid last-minute price hassles with prepaid taxi bookings from Pune to Mumbai Airport. Transparent fares and upfront payment options make your airport transfer hassle-free."
    },
    {
        "name": "Round Trip Cab Pune to Mumbai Airport",
        "description": "Plan your airport transfer with our convenient round trip taxi services from Pune to Mumbai Airport. Whether for pickup or drop, we ensure smooth, comfortable journeys both ways."
    }
],

"tableData": [
    ["Pune to Mumbai Airport Taxi Booking", "One Way Airport Cab Pune to Mumbai"],
    ["Cab for Mumbai International Airport from Pune", "Affordable Pune to Mumbai Airport Taxi"],
    ["Pune to Mumbai Domestic Airport Drop", "AC Cab Hire Pune to Mumbai Airport"],
    ["Sedan/SUV Pune to Mumbai Airport Ride", "24/7 Pune to Mumbai Airport Cab"],
    ["Express Cab Pune to Airport", "Pune to Airport Chauffeur Cab"],
    ["Outstation Cab Pune to Mumbai Airport", "On-Time Cab Pune to Mumbai Airport"],
    ["Airport Transfer Cab Pune to Mumbai", "Prepaid Taxi Pune to Mumbai Airport"],
    ["Round Trip Cab Pune to Mumbai Airport", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Airport Cab Service",
        "WhyChoosedescription": "Meghana Cab offers dependable and punctual cab services from Pune to Mumbai Airport, ensuring you reach your flight on time without any hassle."
    },
    {
        "WhyChooseheading": "Professional Drivers Experienced with Airport Transfers",
        "WhyChoosedescription": "Our drivers are skilled in handling airport routes and assist with luggage, making your Pune to Mumbai Airport journey smooth and comfortable."
    },
    {
        "WhyChooseheading": "Clean and Comfortable Vehicles",
        "WhyChoosedescription": "Travel in sanitized, air-conditioned vehicles that are well-maintained to provide a pleasant experience for your airport transfer."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Enjoy upfront and competitive fares for Pune to Mumbai Airport cabs with no hidden charges, making your travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Availability for Early and Late Flights",
        "WhyChoosedescription": "Our Pune to Mumbai Airport cab service operates round-the-clock, accommodating flights arriving or departing at any hour."
    },
    {
        "WhyChooseheading": "Easy and Quick Booking Process",
        "WhyChoosedescription": "Book your Pune to Mumbai Airport cab quickly through our website, app, or customer support with instant confirmation and real-time tracking."
    },
    {
        "WhyChooseheading": "On-Time Pickup Guarantee",
        "WhyChoosedescription": "We prioritize punctuality to ensure you reach Mumbai Airport well in advance of your flight departure."
    },
    {
        "WhyChooseheading": "Flexible Pickup Locations in Pune",
        "WhyChoosedescription": "We offer pickup from any convenient location in Pune, whether it’s your home, hotel, or office, for seamless airport transfers."
    }
]



































    }

const faqData = [
    {
        question: "How can I book a cab from Pune to Mumbai Airport with Meghana Cab?",
        answer: "You can book a Pune to Mumbai Airport cab by calling Meghana Cab at +91 9075462128 or via our online booking platform."
    },
    {
        question: "Do you provide timely pickups for Pune to Mumbai Airport transfers?",
        answer: "Yes, our drivers monitor flight timings to ensure punctual pickups and timely arrival at Mumbai Airport."
    },
    {
        question: "What types of vehicles are available for Pune to Mumbai Airport trips?",
        answer: "We offer sedans, SUVs, and tempo travellers based on your luggage and group size."
    },
    {
        question: "Can I book a one-way or round trip cab for Pune to Mumbai Airport?",
        answer: "Yes, both one-way and round-trip cab services are available for your convenience."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Mumbai Airport bookings?",
        answer: "Yes, our services operate round-the-clock to accommodate flight schedules."
    },
    {
        question: "Are the vehicles sanitized and safe for travel?",
        answer: "All vehicles are regularly sanitized and maintained to ensure your safety and comfort."
    },
    {
        question: "What is included in the Pune to Mumbai Airport cab fare?",
        answer: "The fare covers driver charges, fuel, and vehicle maintenance. Additional charges like tolls may apply."
    },
    {
        question: "What payment methods are accepted for Pune to Mumbai Airport cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for payment."
    },
    {
        question: "Can Meghana Cab accommodate large groups traveling to Mumbai Airport?",
        answer: "Yes, we offer tempo travellers and SUVs suitable for larger groups and extra luggage."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Mumbai Airport cab service?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to Mumbai Airport cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Karan Shah',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Mumbai Airport cab service by Meghana Cab was punctual and comfortable. Highly recommended!”',
    },
    {
        name: 'Ms. Rhea Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I booked a cab to Mumbai Airport from Pune with Meghana Cab. The driver was courteous and the ride smooth.”',
    },
];





























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







// ✅ JSON-LD objects (define above your Helmet)
const cabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.meghanacabs.com/pune-to-mumbai-airport-cab#service",
  "serviceType": "Pune to Mumbai Airport Cab",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com/"
  },
  "areaServed": [
    "Pune","Hinjawadi","Kharadi","PCMC",
    "Mumbai","CSMIA T1","CSMIA T2","Andheri","Vile Parle","Bandra","Navi Mumbai","Thane","Panvel","Maharashtra"
  ],
  "description": "Book Pune to Mumbai Airport cab (CSMIA T1/T2) with fixed, transparent fares. Clean AC Sedan & SUV, verified drivers, on-time pickup, and 24x7 support.",
  "offers": {
    "@type": "AggregateOffer",
    "priceCurrency": "INR",
    "lowPrice": "2299",
    "highPrice": "6999",
    "offerCount": "12",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-airport-cab"
  },
  "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "ratingCount": 7118 }
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://www.meghanacabs.com/#biz",
  "name": "Meghana Cabs",
  "url": "https://www.meghanacabs.com/",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-mumbai-airport-cab.jpg",
  "priceRange": "₹₹",
  "address": { "@type": "PostalAddress", "addressLocality": "Pune", "addressRegion": "MH", "addressCountry": "IN" },
  "areaServed": ["Pune","Mumbai","CSMIA T1","CSMIA T2","Andheri","Vile Parle","Navi Mumbai","Thane","Panvel"],
  "openingHoursSpecification": [{
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
    "opens": "00:00",
    "closes": "23:59"
  }],
  "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "ratingCount": 6842 }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.meghanacabs.com/" },
    { "@type": "ListItem", "position": 2, "name": "Pune to Mumbai Airport Cab", "item": "https://www.meghanacabs.com/pune-to-mumbai-airport-cab" }
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you offer fixed fares to Mumbai Airport (T1/T2)?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes, we provide upfront fixed fares for Pune to CSMIA T1 and T2—no surge pricing." }
    },
    {
      "@type": "Question",
      "name": "What’s the typical travel time from Pune to Mumbai Airport?",
      "acceptedAnswer": { "@type": "Answer", "text": "Usually 3.5–5 hours via Expressway, depending on time of day and traffic conditions." }
    },
    {
      "@type": "Question",
      "name": "Which cab types can I book?",
      "acceptedAnswer": { "@type": "Answer", "text": "AC Sedan, SUV, and premium cars—clean, well-maintained, and driven by verified professionals." }
    },
    {
      "@type": "Question",
      "name": "Is early-morning pickup available?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes. We support 24x7 operations with on-time pickups, flight tracking, and driver coordination." }
    }
  ]
};





    return (
        <div>


<Helmet>
  <title>Pune to Mumbai Airport Cab (CSMIA T1/T2) | Fixed Fare Taxi | Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune to Mumbai Airport cab (CSMIA T1/T2). Fixed fares, AC Sedan & SUV, verified drivers, 24x7 support, on-time pickup. Instant online booking with Meghana Cabs."
  />
  <link rel="canonical" href="https://www.meghanacabs.com/pune-to-mumbai-airport-cab" />
  <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />

  {/* Optional meta keywords */}
  <meta
    name="keywords"
    content="Pune to Mumbai Airport Cab, Pune to CSMIA Taxi, Pune to T1 Cab, Pune to T2 Cab, Fixed Fare Airport Taxi, Pune to Mumbai Airport Drop, Sedan SUV Cab Pune to Airport"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Pune to Mumbai Airport Cab | Meghana Cabs" />
  <meta
    property="og:description"
    content="Reliable Pune → CSMIA T1/T2 cab with fixed fares, AC cars, and 24x7 support."
  />
  <meta property="og:url" content="https://www.meghanacabs.com/pune-to-mumbai-airport-cab" />
  <meta property="og:image" content="https://www.meghanacabs.com/assets/images/pune-to-mumbai-airport-cab.jpg" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Pune to Mumbai Airport Cab | Meghana Cabs" />
  <meta
    name="twitter:description"
    content="Book Pune → Mumbai Airport cab (T1/T2). Fixed fare, AC Sedan & SUV, verified drivers."
  />
  <meta name="twitter:image" content="https://www.meghanacabs.com/assets/images/pune-to-mumbai-airport-cab.jpg" />

  {/* JSON-LD */}
  <script type="application/ld+json">{JSON.stringify(cabServiceSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
</Helmet>




            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/25.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiairportcab;